import { render, staticRenderFns } from "./AddValues.vue?vue&type=template&id=27497b08&scoped=true&"
import script from "./AddValues.vue?vue&type=script&lang=js&"
export * from "./AddValues.vue?vue&type=script&lang=js&"
import style0 from "./AddValues.vue?vue&type=style&index=0&id=27497b08&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27497b08",
  null
  
)

export default component.exports